import type { ResourceConfig } from "../types";

export const goalTemplateConfig = {
  displayName: "目标模板",
  category: "goal-template",
  permissions: {
    "read:all": {
      label: "查看目标模板",
      description: "可以查看各教练等级的目标模板",
    },
    "write:all": {
      label: "编辑目标模板",
      description: "可以编辑和重置各教练等级的目标模板",
    },
  },
} satisfies ResourceConfig;
